module.exports = __webpack_public_path__ + "static/img/wal.c1afd6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/wal.jpg
// module id = jURH
// module chunks = 0